module.exports = __webpack_public_path__ + "img/category-sport.54f7ae23.png";